import { render, staticRenderFns } from "./ScrollBar.vue?vue&type=template&id=2b41b39e&scoped=true&"
import script from "./ScrollBar.vue?vue&type=script&lang=js&"
export * from "./ScrollBar.vue?vue&type=script&lang=js&"
import style0 from "./ScrollBar.vue?vue&type=style&index=0&id=2b41b39e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b41b39e",
  null
  
)

export default component.exports